import type { Area as AreaType } from '@/types/area'
import { WorkstationItem } from './WorkstationItem/WorkstationItem'
import styles from './Area.module.scss'
import { useAreaStore } from '@/modules/Areas/store'
import { InactiveWorkstationItem } from './WorkstationItem/InactiveWorkstationItem'

export const Area = ({ area }: { area: AreaType }) => {
    const { selectedAreaCode } = useAreaStore()

    const filteredWorkstations =
        selectedAreaCode === 'night'
            ? area.workstations.filter((workstation) => workstation.isNightNetwork)
            : area.workstations

    if (!filteredWorkstations.length) return null

    return (
        <div className={styles.area}>
            {selectedAreaCode === 'all' && <div className={styles.title}>{area.title}</div>}

            <div className={styles.workstationsContainer}>
                {filteredWorkstations.map((workstation, index) =>
                    !workstation.routes.length ? (
                        <InactiveWorkstationItem key={`${workstation.number}-${index}`} workstation={workstation} />
                    ) : (
                        <WorkstationItem key={`${workstation.number}-${index}`} workstation={workstation} />
                    )
                )}
            </div>
        </div>
    )
}
